import {
  createStylesParam,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

export const styles = {
  textFieldBackgroundColor: createStylesParam('textFieldBackgroundColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  }),

  textFieldBorderColor: createStylesParam('textFieldBorderColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.2),
  }),

  textFieldBorderWidth: createStylesParam('textFieldBorderWidth', {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  }),

  textFieldBorderRadius: createStylesParam('textFieldBorderRadius', {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  }),

  textFieldPlaceholderColor: createStylesParam('textFieldPlaceholderColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4'),
  }),

  textFieldFont: createStylesParam('textFieldFont', {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 14 }),
  }),

  textFieldColor: createStylesParam('textFieldColor', {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
};
